const Brand = 'FlipDish';
const Currency = '$';

export { Brand, Currency };